export default __webpack_public_path__ + "static/media/14_SchererGruppe-DTM-Documentary-EschweilerPhotography_21A3684.88efd36f.jpg";